module.exports = __webpack_public_path__ + "static/img/backCircle2.31ca240a.png";